import _ from 'lodash'

export const getPackIndexById = (projects, projectId) => _.findIndex(projects, project => project.id === projectId)
